"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AvatarGroupContext: function() {
        return AvatarGroupContext;
    },
    AvatarGroupProvider: function() {
        return AvatarGroupProvider;
    },
    useAvatarGroupContext_unstable: function() {
        return useAvatarGroupContext_unstable;
    }
});
const _reactcontextselector = require("@fluentui/react-context-selector");
const AvatarGroupContext = (0, _reactcontextselector.createContext)(undefined);
const avatarGroupContextDefaultValue = {};
const AvatarGroupProvider = AvatarGroupContext.Provider;
const useAvatarGroupContext_unstable = (selector)=>(0, _reactcontextselector.useContextSelector)(AvatarGroupContext, (ctx = avatarGroupContextDefaultValue)=>selector(ctx));
